import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "oidc-react";
import visileColumns from "./visibleColumns";
import CustomizerContext from "../../../../_helper/Customizer";
import ErrorBoundary from "../../../../ErrorBoundry";
import { getter } from "@progress/kendo-react-common";
import { getSelectedState } from "@progress/kendo-react-data-tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListUl, faTimes } from "@fortawesome/pro-duotone-svg-icons";
import ApplicantsListByEligibility from "../ApplicantsListByEligibility/ApplicantsListByEligibility";
import { Typography } from "@mui/material";
import { advanceSearch as advanceSearchService } from "../../../../_helper/services/advanceSearchv2";
import { getEmployeeSignatureByControlNumberAPI } from "../../../../_helper/services/employeeSignatures";
import { get, post } from "../../../../_helper/api_helper";
import { ShowError } from "../../../../_helper/helper";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import guamLogo1 from "../../../../assets/GuamLogo.png";
import guamSeal from "../../../../assets/GuamSeal.svg";
import { getFormalApiErrorMessage } from "../../../../utils/apiError";

function EligibilityTable({ setCurrentStep, annId = null }) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const location = useLocation();
    const id = "EligListsByAnnouncement";
    const idv = "All_eligibilitylist";
    const { setApplicantTableShow, EligibilityTableShow, setSingleEligibilityList, setAllApplicantsData, allApplicantsData } = useContext(CustomizerContext);
    const ANNOUNCEMENT_ID_Value = useMemo(() => {
        const { ANNOUNCEMENT_ID } = EligibilityTableShow
        if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim()
        return ""
    }, [EligibilityTableShow])

    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2, error, currentID } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const currentId = location.pathname !== '/eligibilityList' ? id : idv;
        const searchResult = searchResultsV2[currentId] || { results: [], rowCount: 0 };
        return {
            results: searchResult.results,
            rowCount: searchResult.rowCount,
        };
    }, [searchResultsV2, location.pathname]);
    const { userData } = useAuth();
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([{ field: "", dir: "desc" }]);
    const [searchParams, setSearchParams] = useState(
        ANNOUNCEMENT_ID_Value
            ? [{ columnName: "announcement_id", value: ANNOUNCEMENT_ID_Value, operator: "=", dataType: "varchar(50)", logicOperator: "AND" }]
            : []
    );
    const [pageSize, setPageSize] = useState(storePageSize[location.pathname !== '/eligibilityList' ? id : idv] || 100);
    const [deleteData, setDeleteData] = useState(null);
    const [gg1ExportParams, setGG1ExportParams] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [sortedColumns, setSortedColumns] = useState(visileColumns);

    const { postingResult, loading } = useSelector((state) => state.JobAnnouncementReducer);

    const [modal, setModal] = useState(false);
    const [jobOpenings, setJobOpenings] = useState(0);
    const [showAllApplicants, setShowAllApplicants] = useState(false);
    const [dataState, setDataState] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [applicantsByElgModal, setApplicantsByElgModal] = useState(false)
    const [isViewPdfDownloading, setIsViewPdfDownloading] = useState(false);
    const [hasShownApiError, setHasShownApiError] = useState(false);


    const DATA_ITEM_KEY = "eligibility_id";
    const SELECTED_FIELD = "selected";
    const idGetter = getter(DATA_ITEM_KEY);
    useEffect(() => {
        let temp = {}
        if (allApplicantsData && allApplicantsData.length > 0) {
            for (let item of allApplicantsData) {
                if (item.hasOwnProperty("selected") && item?.selected) {
                    temp[item.eligibility_id] = item?.selected
                }
            }
            setSelectedState(temp)
        }
    }, [allApplicantsData])

    const newResults = useMemo(
        () => (results?.length > 0 ? JSON.stringify(results) : ""),
        [searchResultsV2]
    );

    const onSelectionChange = React.useCallback(
        (event) => {
            const clickedId = idGetter(event.dataItem)?.toString();
            const isChecked = event?.syntheticEvent?.target?.checked;
            const selectedIds = Object.keys(selectedState).filter((item) => selectedState[item]);

            if (!isChecked) {
                setSelectedState({});
                return;
            }

            const hasAnotherSelected = selectedIds.some((item) => item !== clickedId);
            if (hasAnotherSelected) {
                alert("Only one eligibility list can be selected at a time.");
                return;
            }

            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );
    const onHeaderSelectionChange = React.useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const selectableCount = Array.isArray(event.dataItems) ? event.dataItems.length : 0;

        if (checked && selectableCount > 1) {
            alert("Only one eligibility list can be selected at a time.");
            return;
        }
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
    }, []);
    useEffect(() => {
        if (results) {
            const allValue = Object.keys(selectedState);
            const tempResults = results?.map((dataItem) =>
                Object.assign(
                    {
                        selected: allValue.includes(dataItem[DATA_ITEM_KEY].toString()),
                    },
                    dataItem
                )
            );
            setDataState([...tempResults]);
        }
    }, [newResults, searchResultsV2, location.pathname]);
    useEffect(() => {
        let tempDataState = [...dataState];
        setDataState(
            tempDataState.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
            }))
        );
    }, [selectedState]);

    useEffect(() => {
        if (ANNOUNCEMENT_ID_Value) {
            setSearchParams([{ columnName: "announcement_id", value: ANNOUNCEMENT_ID_Value, operator: "=", dataType: "varchar(50)", logicOperator: "AND" }]);
        }
    }, [ANNOUNCEMENT_ID_Value])

    const toggleModal = () => setModal(!modal);

    const getParamData = (data) => {
        setGG1ExportParams(data);
    };

    const escapeHtml = (value) =>
        String(value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    const formatHeaderDate = (value) => {
        if (!value) return "-";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return escapeHtml(value);
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
        }).format(date);
    };
    const formatTableDate = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value ?? "").trim();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${month}-${day}-${year}`;
    };
    const formatReportCellValue = (value, fieldName = "") => {
        if (value === null || value === undefined) return "";

        const textValue = String(value).trim();
        if (!textValue) return "";

        const lowerField = String(fieldName || "").toLowerCase();
        const looksLikeDateField = /(date|posted|closed|expire|expiry|start|end)/.test(lowerField);
        const looksLikeIsoDate = /^\d{4}-\d{2}-\d{2}(t.*)?$/i.test(textValue);

        if (looksLikeDateField || looksLikeIsoDate) {
            const formatted = formatTableDate(textValue);
            if (formatted !== escapeHtml(textValue)) return formatted;
        }

        return textValue;
    };
    const getApplicationCountCellValue = (rowData, rowKey, columnKey) => {
        const value = rowData || {};
        const normalize = (text) => String(text || "").toLowerCase().replace(/[^a-z0-9]/g, "");
        const rowTokens = {
            received: ["received", "recvd"],
            qualified: ["qualified", "qualify"],
            notQualified: ["notqualified", "notqual", "nonqualified"],
            rejected: ["rejected"],
            cancelled: ["cancelled", "canceled", "cancel"],
            unknown: ["unknown"],
        };
        const columnTokens = {
            transfers: ["transfer", "transfers"],
            promotion: ["promotion", "promotions", "promote"],
            demotion: ["demotion", "demotions", "demote"],
            open: ["open", "opening"],
            unknown: ["unknown"],
            totals: ["total", "totals"],
        };

        // Prefer structured API shape: applicantCount.<row>.<column>
        const structuredRow = value?.applicantCount?.[rowKey];
        if (structuredRow && typeof structuredRow === "object") {
            const structuredColumnKey = columnKey === "totals" ? "total" : columnKey;
            const structuredValue = structuredRow?.[structuredColumnKey];
            if (structuredValue !== null && structuredValue !== undefined && String(structuredValue).trim() !== "") {
                return escapeHtml(structuredValue);
            }
        }

        // Fallback to legacy flattened key matching used by data.
        const rowMatches = rowTokens[rowKey] || [normalize(rowKey)];
        const colMatches = columnTokens[columnKey] || [normalize(columnKey)];

        const matchedEntry = Object.entries(value).find(([key, itemValue]) => {
            if (itemValue === null || itemValue === undefined || String(itemValue).trim() === "") return false;
            const keyText = normalize(key);
            const hasRowMatch = rowMatches.some((token) => keyText.includes(token));
            const hasColMatch = colMatches.some((token) => keyText.includes(token));
            return hasRowMatch && hasColMatch;
        });

        return matchedEntry ? escapeHtml(matchedEntry[1]) : "&nbsp;";
    };

    const getPdfReportRows = async () => {
        const currentId = location.pathname !== '/eligibilityList' ? id : idv;
        const tableName = location.pathname !== '/eligibilityList' ? "EligListsByAnnouncement" : "All_eligibilitylist";
        const storedSearchParams = searchParameter[currentId]?.searchParams;
        const parsedSearchParams = storedSearchParams?.length
            ? JSON.parse(storedSearchParams)
            : (location.pathname === '/eligibilityList' ? [] : searchParams);

        const sortString = (sortData || [])
            .filter((item) => item?.field && item?.dir)
            .map((item) => `[${item.field}] ${item.dir}`)
            .join(", ");

        const payload = {
            tableName,
            searchParams: JSON.stringify(parsedSearchParams || []),
            columns: "*",
            location: "pmis-global",
            pageNumber: 1,
            pageSize: 9999,
            sortData: sortString,
            additionalWhere: additionalWhere ?? "",
            qID: 0,
        };

        const response = await advanceSearchService(payload);
        return Array.isArray(response?.results) ? response.results : [];
    };

    const downloadEligibilityReport = async () => {
        if (isViewPdfDownloading) return;

        let reportData = [];
        try {
            reportData = await getPdfReportRows();
        } catch (error) {
            ShowError(
                getFormalApiErrorMessage(
                    error,
                    "We are unable to retrieve eligibility report data at this time. Please try again shortly."
                )
            );
            reportData = Array.isArray(dataState) ? dataState : [];
        }

        if (!reportData.length) {
            ShowError("No eligibility data available to generate report.");
            return;
        }

        const reportColumns = (sortedColumns || [])
            .filter((col) => col?.show && !col?.remove && col?.field && col.field !== SELECTED_FIELD)
            .map((col) => ({
                field: col.field,
                title: col.title || col.field,
            }));

        if (!reportColumns.length) {
            ShowError("No visible columns found for report generation.");
            return;
        }

        const ROWS_PER_PAGE = 20;
        const rowChunks = [];
        for (let i = 0; i < reportData.length; i += ROWS_PER_PAGE) {
            rowChunks.push(reportData.slice(i, i + ROWS_PER_PAGE));
        }

        const buildTableHeaderHtml = () =>
            reportColumns
                .map(
                    (column) =>
                        `<th style="border: 1px solid #000; padding: 6px; font-size: 11px; text-align: left; vertical-align: top;">${escapeHtml(column.title)}</th>`
                )
                .join("");

        const buildTableRowsHtml = (rows = []) =>
            rows
                .map((row) => {
                    const cells = reportColumns
                        .map((column) => {
                            const value = formatReportCellValue(row?.[column.field], column.field);
                            return `<td style="padding: 5px; font-size: 10px; vertical-align: top;">${escapeHtml(value)}</td>`;
                        })
                        .join("");
                    return `<tr>${cells}</tr>`;
                })
                .join("");

        const buildPageHtml = (rowsHtml, pageNo, totalPages) => `
<div style="font-family: Courier New, Courier, monospace; font-size: 14px; line-height: 18px; padding: 2px; color: #000; background: #fff; width: 1024px;">
<table width="100%" cellpadding="0" cellspacing="0" style="font-family:Courier New, Courier, monospace;">
<tr style="height:92px;">
<td width="20%" align="center" valign="middle" style="padding-top:6px; padding-bottom:6px;"><img src="${guamSeal}" width="78" /></td>
<td width="60%" align="center" valign="middle">
<table cellpadding="0" cellspacing="0" width="100%">
<tr><td align="center" style="font-size:16px;">GOVERNMENT OF GUAM</td></tr>
<tr><td align="center" style="font-size:16px;">DEPARTMENT OF ADMINISTRATION</td></tr>
<tr><td align="center" style="font-size:16px;">DIVISION OF PERSONNEL MANAGEMENT</td></tr>
<tr><td align="center" style="font-size:16px;">LIST OF ELIGIBLES</td></tr>
</table>
</td>
<td width="20%" align="center" valign="middle" style="padding-top:6px; padding-bottom:6px;"><img src="${guamLogo1}" width="78" /></td>
</tr>
</table>
<table width="100%" cellpadding="0" cellspacing="0">
<tr><td height="10"></td></tr>
<tr><td style="border-top:1px solid #000;"></td></tr>
</table>
<table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:8px;">
<tr>
<td style="font-size:12px; padding:4px 2px;"><b>Eligibility List Report</b></td>
<td style="font-size:11px; text-align:right; padding:4px 2px;">Generated: ${formatHeaderDate(new Date())} | Page ${pageNo} of ${totalPages}</td>
</tr>
</table>
<table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse; table-layout: fixed; border: 1px solid #000;">
<thead>
<tr>
${buildTableHeaderHtml()}
</tr>
</thead>
<tbody>
${rowsHtml}
</tbody>
</table>
</div>
`;

        const containers = [];
        try {
            setIsViewPdfDownloading(true);
            const directorSignature = await getDirectorSignatureDetails();

            const createContainer = (html) => {
                const el = document.createElement("div");
                el.style.cssText = "position:fixed;left:-10000px;top:0;width:1024px;background:#fff;padding:0;z-index:-1;";
                el.innerHTML = html;
                document.body.appendChild(el);
                containers.push(el);
                return el;
            };
            const captureCanvas = (el) => html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });

            const pdf = new jsPDF("p", "pt", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const marginX = 6;
            const marginY = 8;
            const contentWidth = pageWidth - marginX * 2;

            for (let i = 0; i < rowChunks.length; i++) {
                const isLastPage = i === rowChunks.length - 1;
                const rowsHtml = buildTableRowsHtml(rowChunks[i]);
                const pageHtml = buildPageHtml(rowsHtml, i + 1, rowChunks.length);
                const canvas = await captureCanvas(createContainer(pageHtml));
                const imgData = canvas.toDataURL("image/png");
                const imgHeight = (canvas.height * contentWidth) / canvas.width;

                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "PNG", marginX, marginY, contentWidth, imgHeight, undefined, "FAST");

                if (isLastPage) {
                    const signatureEl = createContainer(`
<div style="font-family: Courier New, Courier, monospace; font-size: 14px; line-height: 18px; color: #000; background: #fff; width: 1024px;">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr><td height="18" style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
<tr><td style="text-align: right; padding-right: 8px;">
${directorSignature?.signUrl ? `<img src="${escapeHtml(directorSignature.signUrl)}" alt="director-signature" style="display:block; margin-left:auto; width: 170px; max-height: 70px; object-fit: contain;" />` : ""}
${directorSignature?.controlNumber ? `<div style="text-align:right; font-size:12px; margin-top:2px;">${escapeHtml(directorSignature.controlNumber)}</div>` : ""}
For: Director of Administration<br/>Personnel Services Administrator
</td></tr>
</table>
</div>`);
                    const sigCanvas = await captureCanvas(signatureEl);
                    const sigImgData = sigCanvas.toDataURL("image/png");
                    const sigImgHeight = (sigCanvas.height * contentWidth) / sigCanvas.width;
                    const sigY = marginY + imgHeight + 4;
                    pdf.addImage(sigImgData, "PNG", marginX, sigY, contentWidth, sigImgHeight, undefined, "FAST");
                }
            }

            pdf.save(`Eligibility_Report_${new Date().getTime()}.pdf`);
        } catch (error) {
            ShowError("We were unable to generate the eligibility report at this time. Please try again.");
        } finally {
            containers.forEach((el) => el?.parentNode?.removeChild(el));
            setIsViewPdfDownloading(false);
        }
    };

    const getDummyPdfDataForViewAction = (baseData = {}) => {
        const fallbackAnnouncementId = String(baseData?.announcement_id || ANNOUNCEMENT_ID_Value || "ANN-2026-001").trim() || "ANN-2026-001";
        const fallbackEligibilityId = String(baseData?.eligibility_id || "ELG-0001").trim() || "ELG-0001";

        return {
            ...baseData,
            eligibility_id: fallbackEligibilityId,
            announcement_id: fallbackAnnouncementId,
            status: "Eligible",
            status_desc: "Eligible",
            date_established: "2026-01-15",
            expiry_date: "2026-12-31",
            start_date: "2026-02-01",
            end_date: "2026-11-30",
            remarks: "Dummy data preview for PDF layout verification.",
            PositionTitle: "Program Analyst (Dummy)",
            ann_status: "Open",
            announcement_status: "Open Competitive",
            announcement_type: "Civil Service",
            posted_date: "2026-01-10",
            closed_date: "2026-02-10",
            received_transfers: "4",
            received_promotion: "7",
            received_demotion: "1",
            received_open: "12",
            received_unknown: "0",
            received_totals: "24",
            qualified_transfers: "3",
            qualified_promotion: "5",
            qualified_demotion: "1",
            qualified_open: "10",
            qualified_unknown: "0",
            qualified_totals: "19",
            notqualified_transfers: "1",
            notqualified_promotion: "1",
            notqualified_demotion: "0",
            notqualified_open: "2",
            notqualified_unknown: "0",
            notqualified_totals: "4",
            rejected_transfers: "0",
            rejected_promotion: "1",
            rejected_demotion: "0",
            rejected_open: "1",
            rejected_unknown: "0",
            rejected_totals: "2",
            cancelled_transfers: "0",
            cancelled_promotion: "0",
            cancelled_demotion: "0",
            cancelled_open: "1",
            cancelled_unknown: "0",
            cancelled_totals: "1",
            unknown_transfers: "0",
            unknown_promotion: "0",
            unknown_demotion: "0",
            unknown_open: "0",
            unknown_unknown: "0",
            unknown_totals: "0",
        };
    };

    const getDummyApplicantsForFrontEndPdf = () => {
        return [
            { fullnameLFM: "John A Doe", emp_ssn: "***-**-1234", appllicant_descr: "Transfer", evaluation_rating: "95.50", Qyalify_descr: "Qualified", eligibility_remarks: "Top scored" },
            { fullnameLFM: "Maria K Smith", emp_ssn: "***-**-7788", appllicant_descr: "Promotion", evaluation_rating: "91.00", Qyalify_descr: "Qualified", eligibility_remarks: "Good interview" },
            { fullnameLFM: "David R Clark", emp_ssn: "***-**-8899", appllicant_descr: "Open", evaluation_rating: "86.25", Qyalify_descr: "Not Qualified", eligibility_remarks: "Missing requirement" },
            { fullnameLFM: "Nina P Jones", emp_ssn: "***-**-6655", appllicant_descr: "Open", evaluation_rating: "89.75", Qyalify_descr: "Qualified", eligibility_remarks: "Eligible" },
        ];
    };

    const getEligibilityReportData = async ({ announcementId, eligibilityList }) => {
        const baseURL = process.env.REACT_APP_API_DOTNET_URL;
        const query = `announcementId=${encodeURIComponent(announcementId)}&eligibilityList=${encodeURIComponent(eligibilityList)}`;
        return post(`${baseURL}/JobReports/EligiblesReports?${query}`);
    };

    const getDirectorSignatureDetails = async () => {
        const directorSignControlNumber = String(process.env.REACT_APP_PAYROLL_ESIGN || "").trim();
        if (!directorSignControlNumber) {
            return { signUrl: "", controlNumber: "" };
        }

        try {
            const response = await getEmployeeSignatureByControlNumberAPI(directorSignControlNumber);
            const signData = response?.data || response || {};
            return {
                signUrl: String(signData?.signUrl || signData?.SignUrl || "").trim(),
                controlNumber: String(signData?.controlNumber || signData?.ControlNumber || directorSignControlNumber).trim(),
            };
        } catch (error) {
            return {
                signUrl: "",
                controlNumber: directorSignControlNumber,
            };
        }
    };

    const downloadEligibilityReportDummyFromFrontend = async (viewData) => {
        if (isViewPdfDownloading) return;

        const normalizeText = (value) => String(value ?? "").trim();
        const eligibilityId = normalizeText(viewData?.eligibility_id || viewData?.ELIGIBILITY_ID);
        const announcementId = normalizeText(viewData?.announcement_id || viewData?.ANNOUNCEMENT_ID || ANNOUNCEMENT_ID_Value);

        if (!eligibilityId) {
            ShowError("Eligibility ID not found for this row.");
            return;
        }
        if (!announcementId) {
            ShowError("Announcement ID not found for this row.");
            return;
        }

        let apiReportData = null;
        try {
            apiReportData = await getEligibilityReportData({ announcementId, eligibilityList: eligibilityId });
        } catch (error) {
            ShowError(
                getFormalApiErrorMessage(
                    error,
                    "We are unable to retrieve the eligibility report details at this time. Please try again shortly."
                )
            );
            return;
        }

        const announcement = apiReportData?.announcement || {};
        const applicantsFromApi = Array.isArray(apiReportData?.applicants) ? apiReportData.applicants : [];
        const firstApplicant = applicantsFromApi[0] || {};

        const dataItem = {
            ...getDummyPdfDataForViewAction(viewData || {}),
            eligibility_id: eligibilityId,
            announcement_id: normalizeText(announcement?.announcemenT_ID) || announcementId,
            PositionTitle: normalizeText(announcement?.position) || normalizeText(viewData?.PositionTitle),
            ann_status: normalizeText(announcement?.status) || normalizeText(viewData?.ann_status),
            status: normalizeText(viewData?.status || announcement?.status) || "-",
            announcement_type: normalizeText(announcement?.announcemenT_TYPE) || normalizeText(viewData?.announcement_type),
            posted_date: announcement?.datE_POSTED || viewData?.posted_date,
            closed_date: announcement?.datE_CLOSED || viewData?.closed_date,
            date_established: firstApplicant?.date_established || viewData?.date_established,
            expiry_date: firstApplicant?.date_expires || viewData?.expiry_date,
            remarks: normalizeText(firstApplicant?.eligibility_remarks) || normalizeText(viewData?.remarks),
            applicantCount: apiReportData?.applicantCount || {},
        };

        const apiApplicants = applicantsFromApi.map((applicant) => ({
            fullnameLFM: normalizeText(applicant?.fullnameLFM || `${normalizeText(applicant?.lname)}, ${normalizeText(applicant?.fname)} ${normalizeText(applicant?.mname)}`),
            emp_ssn: normalizeText(applicant?.emp_ssn),
            appllicant_descr: normalizeText(applicant?.appllicant_descr || applicant?.applicant_type),
            evaluation_rating: String(applicant?.evaluation_rating ?? applicant?.Score ?? "").trim(),
            Qyalify_descr: normalizeText(applicant?.Qyalify_descr),
            eligibility_remarks: normalizeText(applicant?.eligibility_remarks),
        }));

        const applicantsForPdf = apiApplicants.length ? apiApplicants : getDummyApplicantsForFrontEndPdf();
        const directorSignature = await getDirectorSignatureDetails();

        const ROWS_PER_PAGE = 30;
        const applicantChunks = [];
        for (let i = 0; i < applicantsForPdf.length; i += ROWS_PER_PAGE) {
            applicantChunks.push(applicantsForPdf.slice(i, i + ROWS_PER_PAGE));
        }
        if (applicantChunks.length === 0) applicantChunks.push([]);

        const buildApplicantRowsHtml = (chunk) =>
            chunk.map((applicant) => `
<tr>
<td style="padding: 4px;">${escapeHtml(applicant.fullnameLFM)}</td>
<td style="padding: 4px; text-align: center;">${escapeHtml(applicant.emp_ssn)}</td>
<td style="padding: 4px; text-align: center;">${escapeHtml(applicant.appllicant_descr)}</td>
<td style="padding: 4px; text-align: center;">${escapeHtml(applicant.evaluation_rating)}</td>
<td style="padding: 4px; text-align: center;">${escapeHtml(applicant.Qyalify_descr)}</td>
<td style="padding: 4px;">${escapeHtml(applicant.eligibility_remarks)}</td>
</tr>
`).join("");

        const buildPageHtml = (applicantRowsHtml, isFirstPage) => `
<div style="font-family: Courier New, Courier, monospace; font-size: 14px; line-height: 18px; padding: 2px; color: #000; background: #fff; width: 1024px;">
<table width="100%" cellpadding="0" cellspacing="0" style="font-family:Courier New, Courier, monospace;">
<tr style="height:92px;">
<td width="20%" align="center" valign="middle" style="padding-top:6px; padding-bottom:6px;"><img src="${guamSeal}" width="78" /></td>
<td width="60%" align="center" valign="middle">
<table cellpadding="0" cellspacing="0" width="100%">
<tr><td align="center" style="font-size:16px;">GOVERNMENT OF GUAM</td></tr>
<tr><td align="center" style="font-size:16px;">DEPARTMENT OF ADMINISTRATION</td></tr>
<tr><td align="center" style="font-size:16px;">DIVISION OF PERSONNEL MANAGEMENT</td></tr>
<tr><td align="center" style="font-size:16px;">LIST OF ELIGIBLES</td></tr>
</table>
</td>
<td width="20%" align="center" valign="middle" style="padding-top:6px; padding-bottom:6px;"><img src="${guamLogo1}" width="78" /></td>
</tr>
</table>
<table width="100%" cellpadding="0" cellspacing="0">
<tr><td height="10"></td></tr>
<tr><td style="border-top:1px solid #000;"></td></tr>
</table>
<table width="100%" cellpadding="0" cellspacing="0">
<tr><td style="padding-left:18px; padding-right:18px; padding-top:6px;">
${isFirstPage ? `<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="4">
<tr>
<td style="width: 30%; vertical-align: top;">Eligibility Id:&nbsp;&nbsp;${escapeHtml(eligibilityId || "-")}</td>
<td style="width: 70%; vertical-align: top;">Status:&nbsp;&nbsp;${escapeHtml(dataItem?.status || dataItem?.status_desc || "-")}</td>
</tr>
</table>

<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="4">
<tr>
<td style="width: 30%; vertical-align: top;">Date Established:&nbsp;&nbsp;${formatHeaderDate(dataItem?.date_established)}</td>
<td style="width: 20%; vertical-align: top;">Expires:&nbsp;&nbsp;${formatHeaderDate(dataItem?.expiry_date || dataItem?.date_expires)}</td>
<td style="width: 25%; vertical-align: top;">Start Date:&nbsp;&nbsp;${formatHeaderDate(dataItem?.start_date)}</td>
<td style="width: 25%; vertical-align: top;">End Date:&nbsp;&nbsp;${formatHeaderDate(dataItem?.end_date)}</td>
</tr>
</table>

<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="4">
<tr>
<td style="width: 100%; vertical-align: top;">Remarks:&nbsp;&nbsp;${escapeHtml(dataItem?.remarks || "-")}</td>
</tr>
</table>

<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr><td height="8" style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
</table>

<table width="100%" border="1" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
<tr>
<td style="padding: 2px;">
<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="5" cellspacing="0" border="0">
<tr>
<td style="width: 50%; vertical-align: top;">Position:&nbsp;&nbsp;${escapeHtml(dataItem?.PositionTitle || "-")}</td>
<td style="width: 50%; vertical-align: top;">Announcement:&nbsp;${escapeHtml(dataItem?.announcement_id || announcementId || "-")}</td>
</tr>
<tr>
<td style="vertical-align: top;">Ann Status:&nbsp;&nbsp;${escapeHtml(dataItem?.ann_status || dataItem?.status_desc || "-")}</td>
<td style="vertical-align: top;">
<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="3">
<tr>
<td style="width: 50%; vertical-align: top;">Type:&nbsp;${escapeHtml(dataItem?.announcement_status || "-")}</td>
<td style="width: 50%; vertical-align: top;">Category:&nbsp;${escapeHtml(dataItem?.announcement_type || "-")}</td>
</tr>
</table>
</td>
</tr>
<tr>
<td style="vertical-align: top;">Posted:&nbsp;${formatHeaderDate(dataItem?.posted_date || dataItem?.start_date)}</td>
<td style="vertical-align: top;">Closed:&nbsp;${formatHeaderDate(dataItem?.closed_date || dataItem?.end_date)}</td>
</tr>
</table>
</td>
</tr>
</table>

<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr><td height="8" style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
</table>

<table width="100%" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
<tr>
<td align="center">
<table width="68%" border="1" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
<tr>
<td style="padding: 4px 10px 6px 10px;">
<table style="width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 14px; line-height: 16px;" cellpadding="2" cellspacing="0" border="0">
<tr>
<td colspan="7" style="text-align: center; letter-spacing: 10px; padding-bottom: 3px;">APPLICATION COUNT</td>
</tr>
<tr>
<td style="width: 30%;">&nbsp;</td>
<td style="width: 10%; text-align: center;"><b>Transfers</b></td>
<td style="width: 10%; text-align: center;"><b>Promotion</b></td>
<td style="width: 10%; text-align: center;"><b>Demotion</b></td>
<td style="width: 10%; text-align: center;"><b>Open</b></td>
<td style="width: 10%; text-align: center;"><b>Unknown</b></td>
<td style="width: 20%; text-align: center;"><b>Totals</b></td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Received</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "received", "totals")}</td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Qualified</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "qualified", "totals")}</td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Not Qualified</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "notQualified", "totals")}</td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Rejected</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "rejected", "totals")}</td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Cancelled</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "cancelled", "totals")}</td>
</tr>
<tr>
<td style="padding: 4px 8px 4px 2px; white-space: nowrap;">Unknown</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "transfers")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "promotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "demotion")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "open")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "unknown")}</td>
<td style="text-align: center; padding: 4px 2px;">${getApplicationCountCellValue(dataItem, "unknown", "totals")}</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>
</table>

<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr><td height="10" style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
</table>` : ""}

<table style="width: 100%; border-collapse: collapse; table-layout: fixed;" cellpadding="0" cellspacing="0" border="1">
<tr>
<td style="padding: 4px; width: 24%;"><b>Name</b></td>
<td style="padding: 4px; width: 14%; text-align: center;"><b>SSN</b></td>
<td style="padding: 4px; width: 14%; text-align: center;"><b>Applicant Type</b></td>
<td style="padding: 4px; width: 12%; text-align: center;"><b>Rating</b></td>
<td style="padding: 4px; width: 12%; text-align: center;"><b>Elig Status</b></td>
<td style="padding: 4px; width: 24%;"><b>Remarks</b></td>
</tr>
${applicantRowsHtml}
</table>
</td></tr></table>
</div>
`;

        const containers = [];
        try {
            setIsViewPdfDownloading(true);

            const createContainer = (html) => {
                const el = document.createElement("div");
                el.style.cssText = "position:fixed;left:-10000px;top:0;width:1024px;background:#fff;padding:0;z-index:-1;";
                el.innerHTML = html;
                document.body.appendChild(el);
                containers.push(el);
                return el;
            };
            const captureCanvas = (el) => html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });

            const pdf = new jsPDF("p", "pt", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const marginX = 6;
            const marginY = 8;
            const contentWidth = pageWidth - marginX * 2;

            for (let i = 0; i < applicantChunks.length; i++) {
                const isFirstPage = i === 0;
                const isLastPage = i === applicantChunks.length - 1;
                const rowsHtml = buildApplicantRowsHtml(applicantChunks[i]);
                const pageHtml = buildPageHtml(rowsHtml, isFirstPage);

                const canvas = await captureCanvas(createContainer(pageHtml));
                const imgData = canvas.toDataURL("image/png");
                const imgHeight = (canvas.height * contentWidth) / canvas.width;

                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "PNG", marginX, marginY, contentWidth, imgHeight, undefined, "FAST");

                if (isLastPage) {
                    const signatureEl = createContainer(`
<div style="font-family: Courier New, Courier, monospace; font-size: 14px; line-height: 18px; color: #000; background: #fff; width: 1024px;">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr><td height="18" style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
<tr><td style="text-align: right; padding-right: 8px;">
${directorSignature?.signUrl ? `<img src="${escapeHtml(directorSignature.signUrl)}" alt="director-signature" style="display:block; margin-left:auto; width: 170px; max-height: 70px; object-fit: contain;" />` : ""}
${directorSignature?.controlNumber ? `<div style="text-align:right; font-size:12px; margin-top:2px;">${escapeHtml(directorSignature.controlNumber)}</div>` : ""}
For: Director of Administration<br/>Personnel Services Administrator
</td></tr>
</table>
</div>`);
                    const sigCanvas = await captureCanvas(signatureEl);
                    const sigImgData = sigCanvas.toDataURL("image/png");
                    const sigImgHeight = (sigCanvas.height * contentWidth) / sigCanvas.width;
                    const sigY = marginY + imgHeight + 4;
                    pdf.addImage(sigImgData, "PNG", marginX, sigY, contentWidth, sigImgHeight, undefined, "FAST");
                }
            }

            pdf.save(`Eligibility_ViewData_FE_Report_${eligibilityId}_${new Date().getTime()}.pdf`);
        } catch (error) {
            ShowError("We were unable to generate the eligibility PDF at this time. Please try again.");
        } finally {
            containers.forEach((el) => el?.parentNode?.removeChild(el));
            setIsViewPdfDownloading(false);
        }
    };

    const handleReset = () => {
        // Reset any relevant state or dispatch actions if needed
    };

    const actions = useMemo(() => {
        return [
            {
                title: "Eligibility PDF",
                icon: { iconName: "k-icon k-i-file-pdf" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    downloadEligibilityReportDummyFromFrontend(props?.dataItem);
                },
            },
            {
                title: "Show Applicants of Elgibility List",
                icon: { iconName: "k-icon k-i-eye" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    const eligibilityId = props?.dataItem?.eligibility_id?.trim();
                    const announcementId = props?.dataItem?.announcement_id?.trim();
                    if (location.pathname === '/eligibilityList' && eligibilityId) {
                        history(`/eligibilApplicationList/${eligibilityId}/${announcementId || ''}`);
                    } else {
                        setSingleEligibilityList(props.dataItem)
                        setApplicantsByElgModal(true);
                    }
                },
            },
        ];
    }, [location.pathname, additionalWhere, searchParameter, sortedColumns, sortData, searchParams, ANNOUNCEMENT_ID_Value, isViewPdfDownloading]);

    const handleModalSubmit = () => {
        // Logic to handle showing a specific number of applicants
        toggleModal();
        setShowAllApplicants(false);
        // Dispatch action or filter results based on jobOpenings
    };

    useEffect(() => {
        if (loadingSearch) setexpandedSearchResult(true);
    }, [loadingSearch]);

    useEffect(() => {
        if (loadingSearch) {
            setHasShownApiError(false);
            return;
        }

        const activeGridId = location.pathname !== '/eligibilityList' ? id : idv;
        const requestFailed = Boolean(error?.message);
        const isCurrentScreenRequest = currentID === activeGridId;

        if (requestFailed && isCurrentScreenRequest && !hasShownApiError) {
            ShowError(
                "We are unable to load the eligibility list at this time. Please try again shortly. If the issue persists, please contact your system administrator."
            );
            setHasShownApiError(true);
        }
    }, [loadingSearch, error, currentID, location.pathname, hasShownApiError]);

    useEffect(() => {
        // Update state or perform actions based on postingResult and loading state
    }, [postingResult, loading]);

    useEffect(() => {
        const currentId = location.pathname !== '/eligibilityList' ? id : idv;
        if (location.pathname === '/eligibilityList') {
            setSearchParams([]);
        } else {
            const storedStr = searchParameter[currentId]?.searchParams;
            if (storedStr) {
                const parsed = JSON.parse(storedStr);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    setSearchParams(parsed);
                }
            }
        }
    }, [searchParameter, location.pathname]);

    // useEffect(() => {
    //     setSearchParams([
    //         {
    //             columnName: "ANNOUNCEMENT_ID",
    //             operator: "=",
    //             value: "TESTPOIII",
    //             dataType: "varchar",
    //             logicOperator: "AND",
    //         },
    //     ]);
    // }, []);

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const handleCheckboxChange = (event, dataItem) => {
        // Logic for handling checkbox state chang
        // setApplicantTableShow(event.target.checked);
    };

    const renderCheckbox = (props) => {
        return (
            <td>
                <input
                    type="checkbox"
                    checked={props.dataItem.selected}
                    onChange={(event) => handleCheckboxChange(event, props.dataItem)}
                />
            </td>
        );
    };

    const handleApplicantsElgModal = () => {
        setApplicantsByElgModal(!applicantsByElgModal)
    }

    const showAllApplicantsHandler = () => {
        const allSelectedElgIds = Object.keys(selectedState).filter((item) => selectedState[item])
        const allSelectedElgData = dataState.filter((item) => allSelectedElgIds.includes(item.eligibility_id))
        setAllApplicantsData(allSelectedElgData)
        setApplicantTableShow(true)
        if (annId) {
            setCurrentStep(1)
        }
        else {
            setCurrentStep(2)
        }
        // setCurrentStep(2)
    }

    const isShowAllApplicantsButtonVisible = useMemo(() => {
        return Object.values(selectedState).filter((value) => value).length === 1;
    }, [selectedState]);

    return (
        <ErrorBoundary>
            <Fragment>
                <Container fluid={true}>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card style={{ border: '0px' }}>
                                <CardHeader>
                                    <Row className="bg-primary rounded py-2 mb-3">
                                        <Col className="d-flex align-items-center gap-2 justify-content-between">
                                            <div className="d-flex align-items-center gap-2">
                                                <FontAwesomeIcon icon={faListUl} size="xl" />
                                                <Typography variant="h6" style={{ color: "white" }}>
                                                    Eligibility List
                                                </Typography>
                                            </div>
                                            {location.pathname !== '/eligibilityList' && <div className="d-flex align-items-center gap-2 justify-content-end">
                                                <Button disabled={!isShowAllApplicantsButtonVisible} color="secondary" className="ml-2"
                                                    onClick={() => {
                                                        showAllApplicantsHandler()
                                                        setShowAllApplicants(true)
                                                    }
                                                    }>Show All Applicants</Button>
                                            </div>}
                                        </Col>
                                    </Row>
                                </CardHeader>

                                {
                                    location.pathname == '/eligibilityList' &&
                                    <div className="pb-3 pl-0">
                                        <Button
                                            color="primary"
                                            onClick={downloadEligibilityReport}
                                            disabled={!dataState?.length}
                                        >
                                            Download Eligibility Report (PDF)
                                        </Button>
                                    </div>
                                }
                                <CardBody>
                                    <TelerikDataTable
                                        id={location.pathname !== '/eligibilityList' ? id : idv}
                                        pageNumber={page}
                                        pageSize={pageSize}
                                        totalCount={showAllApplicants ? rowCount : Math.min(rowCount, jobOpenings)}
                                        skip={(page - 1) * pageSize}
                                        take={pageSize}
                                        data={dataState || []}
                                        // sortData={sortData}
                                        tableName={location.pathname !== '/eligibilityList' ? "EligListsByAnnouncement" : "All_eligibilitylist"}
                                        searchParams={searchParams}
                                        additionalWhere={additionalWhere}
                                        onFilterChange={handleFilterChange}
                                        onSortChange={handleSortChange}
                                        onPageChange={handlePageChange}
                                        onPageSizeChange={handlePageSizeChange}
                                        selectedColumns={sortedColumns}
                                        setSortedColumns={setSortedColumns}
                                        loading={loadingSearch || isViewPdfDownloading}
                                        enableFooterCell={false}
                                        dataLocation="pmis-global"
                                        actions={actions}
                                        setChooseFilterMethod={setChooseFilterMethod}
                                        showCheckboxes={location.pathname !== '/eligibilityList' ? true : false}
                                        onHeaderSelectionChange={onHeaderSelectionChange}
                                        onSelectionChange={onSelectionChange}
                                        selectedState={selectedState}
                                        dataItemKeyField={DATA_ITEM_KEY}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Number of Job Openings</ModalHeader>
                    <ModalBody>
                        <Input
                            type="number"
                            value={jobOpenings}
                            onChange={(e) => setJobOpenings(e.target.value)}
                            placeholder="Enter number of job openings"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleModalSubmit}>Submit</Button>{' '}
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={applicantsByElgModal}
                    style={{
                        maxWidth: '80%',
                        width: '80%',
                    }}
                    zIndex={99}
                //   size="xl"
                >
                    <ModalHeader>
                        Applicants List
                        <Button close onClick={handleApplicantsElgModal} style={{ position: 'absolute', right: '1rem' }}>
                            {/* <FontAwesomeIcon icon={faTimes} /> */}
                        </Button>
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ zIndex: 9999999 }}>
                            <ApplicantsListByEligibility />
                        </div>
                    </ModalBody>
                </Modal>
            </Fragment>
        </ErrorBoundary>
    );
}

export default EligibilityTable;
